import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateContainerQrRedirectionCampaignForContainerTypeMutationVariables = Types.Exact<{
  type_id: Types.Scalars['Int'];
  container_qr_redirects: Types.CreateContainerQrRedirectionCampaignByContainerTypeInput;
}>;


export type CreateContainerQrRedirectionCampaignForContainerTypeMutation = { __typename?: 'Mutation', createContainerQrRedirectionCampaignForContainerType?: { __typename?: 'ContainerQrRedirectionCampaign', container_type_id: number } | null };


export const CreateContainerQrRedirectionCampaignForContainerTypeDocument = gql`
    mutation createContainerQrRedirectionCampaignForContainerType($type_id: Int!, $container_qr_redirects: CreateContainerQrRedirectionCampaignByContainerTypeInput!) {
  createContainerQrRedirectionCampaignForContainerType(
    type_id: $type_id
    container_qr_redirects: $container_qr_redirects
  ) {
    container_type_id
  }
}
    `;
export type CreateContainerQrRedirectionCampaignForContainerTypeMutationFn = Apollo.MutationFunction<CreateContainerQrRedirectionCampaignForContainerTypeMutation, CreateContainerQrRedirectionCampaignForContainerTypeMutationVariables>;

/**
 * __useCreateContainerQrRedirectionCampaignForContainerTypeMutation__
 *
 * To run a mutation, you first call `useCreateContainerQrRedirectionCampaignForContainerTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContainerQrRedirectionCampaignForContainerTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContainerQrRedirectionCampaignForContainerTypeMutation, { data, loading, error }] = useCreateContainerQrRedirectionCampaignForContainerTypeMutation({
 *   variables: {
 *      type_id: // value for 'type_id'
 *      container_qr_redirects: // value for 'container_qr_redirects'
 *   },
 * });
 */
export function useCreateContainerQrRedirectionCampaignForContainerTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateContainerQrRedirectionCampaignForContainerTypeMutation, CreateContainerQrRedirectionCampaignForContainerTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContainerQrRedirectionCampaignForContainerTypeMutation, CreateContainerQrRedirectionCampaignForContainerTypeMutationVariables>(CreateContainerQrRedirectionCampaignForContainerTypeDocument, options);
      }
export type CreateContainerQrRedirectionCampaignForContainerTypeMutationHookResult = ReturnType<typeof useCreateContainerQrRedirectionCampaignForContainerTypeMutation>;
export type CreateContainerQrRedirectionCampaignForContainerTypeMutationResult = Apollo.MutationResult<CreateContainerQrRedirectionCampaignForContainerTypeMutation>;
export type CreateContainerQrRedirectionCampaignForContainerTypeMutationOptions = Apollo.BaseMutationOptions<CreateContainerQrRedirectionCampaignForContainerTypeMutation, CreateContainerQrRedirectionCampaignForContainerTypeMutationVariables>;